module.exports = __webpack_public_path__ + "static/media/BudgetTracker.b10fc1ba.png";